// extracted by mini-css-extract-plugin
module.exports = {"filter":"CategoryOrdering_filter__VKUFn"};